/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import { SvgElement, icontypesEnum } from "../assets/svgElement";
import { Dispatch } from "redux";
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../../reducer/loginSlice';
import { useNavigate } from 'react-router-dom';
import { AiOutlineSetting } from "react-icons/ai";
import { IoArrowBack } from "react-icons/io5";
import { MdDashboard } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { PortalApis } from "../../apis/PortalApis";
import { AxiosResponse } from "axios";
import { FaKey, FaChartBar, FaWallet, FaPlug, FaBook, FaFileInvoiceDollar } from "react-icons/fa";

export default function PortalSidebar(title: any) {
    const navigate = useNavigate();
    const [collapseShow, setCollapseShow] = React.useState("hidden");
    const dispatch: Dispatch = useDispatch();
    const userLoginData = useSelector((state: any) => state.data.login.value);


    React.useEffect(() => {
        PortalApis.session().then(
            (response: AxiosResponse<any>) => {
                if (response?.data) {
                    ''
                } else {
                    dispatch(login([]))
                    navigate('/api-access/login');
                }
            }
        ).catch(function (error: any) {
            console.log(error);
            console.log("session check failed");
        })
    }, []);

    React.useEffect(() => {
        if (userLoginData?.data?.role !== 'portal') {
            dispatch(login([]))
            navigate('/api-access/login')
        }
    }, []);

    React.useEffect(() => {
        // If partner is pending or rejected, redirect
        if (userLoginData?.data?.status === 'pending') {
            navigate('/api-portal/pending')
        }
        if (userLoginData?.data?.status === 'rejected') {
            navigate('/api-portal/rejected')
        }
    }, []);


    const logOut = () => {
        PortalApis.logout().then(
            (response: AxiosResponse<any>) => {
                if (response?.data) {
                    dispatch(login([]))
                    navigate('/api-access/login');
                }
            }
        ).catch(function (error: any) {
            console.log(error?.response?.data);
            // Still logout locally
            dispatch(login([]))
            navigate('/api-access/login');
        })
    };


    return (
        <>
            <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0  md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl md:bg-[#ffffff]  mt-2 ml-1 relative md:w-64 z-2 py-2 px-1">
                <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
                    {/* Toggler */}
                    <button
                        className="cursor-pointer text-black md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                        type="button"
                        onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
                    >
                        <b className="fas fa-bars text-3xl"> ≡ </b><span className="text-black">{title?.title}</span>
                    </button>
                    {/* Brand */}

                    <span className="flex justify-end md:hidden">
                        <span className="flex  flex-row flex-wrap items-center lg:ml-auto mr-3">
                            <div className="relative flex w-full flex-wrap items-stretch gap-5">
                                <h2 className="pt-2"><SvgElement type={icontypesEnum.SEARCH} /></h2>
                                <h2 className="pt-2"><SvgElement type={icontypesEnum.NOTIFICATION} /></h2>
                                <NavLink to='/api-portal/settings'>
                                    <h2 className=" pt-2"><SvgElement type={icontypesEnum.SETTINGS} /></h2>
                                </NavLink>
                            </div>
                        </span>
                    </span>

                    <Link
                        className="hidden md:pb-6 mt-10 lg:flex justify-center"
                        to="/"
                    >
                        <SvgElement type={icontypesEnum.BARS2} />
                    </Link>

                    {/* API Portal Badge */}
                    <div className="hidden md:flex justify-center mb-2">
                        <span className="bg-[#E04343] text-white text-[10px] font-[600] px-3 py-1 rounded-full">API PORTAL</span>
                    </div>

                    {/* Collapse */}
                    <div
                        className={
                            "md:flex md:flex-col items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow bg-[#ffffff] absolute top-4 left-0 right-1  h-auto flex-1 rounded " +
                            collapseShow
                        }
                    >
                        {/* Collapse header */}
                        <div className="md:min-w-full md:hidden block pb-1 mb-4">
                            <div className="flex justify-between">
                                <span className="flex justify-start gap-1" onClick={() => setCollapseShow("hidden")}><IoArrowBack style={{ color: '#333333' }} className="bg-gray-200 text-xs text-gray-500 rounded-full p-1 h-6 w-6" /> <span className="text-white ml-2">Back</span></span>
                                <span className="cursor-pointer opacity-50 md:hidden py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent" onClick={() => setCollapseShow("hidden")}>
                                    <NavLink to='/api-portal/settings'>
                                        <b className="fas fa-times text-white"> <AiOutlineSetting /> </b>
                                    </NavLink>
                                </span>
                            </div>
                        </div>

                        <ul className="flex-col list-none flex bg-[#ffffff] md:mt-1 mt-2">

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/dashboard" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <MdDashboard className="" size={24} />
                                    <span className="mt-0.5"> Overview</span>
                                </NavLink>
                            </li>

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/api-keys" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <FaKey className="" size={24} />
                                    <span className="mt-0.5">API Keys</span>
                                </NavLink>
                            </li>

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/usage" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <FaChartBar className="" size={24} />
                                    <span className="mt-0.5">Usage</span>
                                </NavLink>
                            </li>

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/wallet" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <FaWallet className="" size={24} />
                                    <span className="mt-0.5">Wallet</span>
                                </NavLink>
                            </li>

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/invoices" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <FaFileInvoiceDollar className="" size={24} />
                                    <span className="mt-0.5">Invoices</span>
                                </NavLink>
                            </li>

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/webhooks" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <FaPlug className="" size={24} />
                                    <span className="mt-0.5">Webhooks</span>
                                </NavLink>
                            </li>

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/docs" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <FaBook className="" size={24} />
                                    <span className="mt-0.5">API Docs</span>
                                </NavLink>
                            </li>

                            <li className="items-center mb-4">
                                <NavLink to="/api-portal/settings" className="flex mx-4 py-[11px] pl-[15px] gap-2 rounded-[5px] text-[14px] text-[#808080] hover:bg-[#FF3B300D] hover:text-[#E04343] hover:border-l-[3px] hover:border-[#E04343]"
                                    style={({ isActive }) =>
                                        isActive ? { color: '#ffffff', background: "#E04343" } : { color: '' }
                                    }
                                >
                                    <IoMdSettings className="" size={24} />
                                    <span className="mt-0.5">Settings</span>
                                </NavLink>
                            </li>

                            <li className="items-center mx-3 pl-3 pt-10">
                                <span className="text-xs cursor-pointer block" onClick={logOut}>
                                    <span className="flex py-2 cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="mr-3" viewBox="0 0 24 24"><path fill="red" d="M16 13v-2H7V8l-5 4l5 4v-3z" /><path fill="red" d="M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z" /></svg>
                                        <span className="text-[15px] mt-1 font-normal text-[#FF0000]">Sign out</span>
                                    </span>
                                </span>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}